import { render } from "./Introductie.vue?vue&type=template&id=44ffe7dd"
import script from "./Introductie.vue?vue&type=script&lang=js"
export * from "./Introductie.vue?vue&type=script&lang=js"

import "./Introductie.vue?vue&type=style&index=0&id=44ffe7dd&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__